// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectTradeSessionStatusMessage } from '@shared/utils/DirectMessages/DirectTradeSessionStatusMessage';
import { SessionOperations } from '@shared/utils/Enums/Constants';
import { Enum } from '@shared/utils/Enum';
import { OrderTif } from '@shared/utils/Trading/OrderTifEnum';
export class TradeSessionStatusMessageProcessor extends MessageProcessorBase {
    constructor() {
        super();
        this.tifValues = Enum.GetEnumValues(OrderTif);
    }
    decode(fieldSet) {
        const msg = new DirectTradeSessionStatusMessage();
        msg.Id = fieldSet.GetValue(FieldsFactory.FIELD_ID);
        msg.Name = fieldSet.GetValue(FieldsFactory.FIELD_NAME);
        msg.IsDecreaseOnlyPositionCount = fieldSet.GetValue(FieldsFactory.FIELD_IS_DECREASE_ONLY_POSITION_COUNT);
        const operations = fieldSet
            .GetValue(FieldsFactory.FIELD_SESSION_ALLOWED_OPERATIONS)
            .split(';')
            .filter(function (el) {
            return el.length > 0;
        });
        if (operations.length > 0) {
            if (operations[0] !== '0') {
                msg.AllowedOperations |= SessionOperations.Open;
            }
            if (operations[1] !== '0') {
                msg.AllowedOperations |= SessionOperations.Modify;
            }
            if (operations[2] !== '0') {
                msg.AllowedOperations |= SessionOperations.Cancel;
            }
        }
        const types = fieldSet
            .GetValue(FieldsFactory.FIELD_SESSION_ALLOWED_ORDER_TYPES)
            .split(';')
            .filter(function (el) {
            return el.length > 0;
        });
        const len = types.length;
        for (let i = 0; i < len; i++) {
            if (types[i] !== '0') {
                msg.AllowedOrderTypes.push(i);
            }
        }
        const tifMask = fieldSet.GetValue(FieldsFactory.FIELD_SESSION_ALLOWED_TIFS);
        if (isNullOrUndefined(tifMask)) {
            /* Use all TIFs if tifMask is null — for migration */
            msg.AllowedTIFs.push(...this.tifValues);
        }
        else {
            for (const tif of this.tifValues) {
                if ((tifMask & (1 << (tif - 1))) !== 0) {
                    msg.AllowedTIFs.push(tif);
                }
            }
        }
        return [msg];
    }
}
